(function(){
  function pad(n){ return (n<10?'0':'')+n; }
  document.querySelectorAll('ul.timer').forEach(function(t, k){
    var h=t.querySelector('[data-hours]'), m=t.querySelector('[data-minutes]'), s=t.querySelector('[data-seconds]');
    var total=((parseInt(h&&h.getAttribute('data-hours'),10)||0)*3600)+((parseInt(m&&m.getAttribute('data-minutes'),10)||0)*60)+(parseInt(s&&s.getAttribute('data-seconds'),10)||0);
    var key='ga_timer_'+k, end=null;
    try{ end=parseInt(localStorage.getItem(key),10); if(!end||end<Date.now()){ end=Date.now()+total*1000; localStorage.setItem(key,String(end)); } }catch(e){ end=Date.now()+total*1000; }
    function tick(){ var r=Math.max(0,Math.floor((end-Date.now())/1000)); if(h) h.textContent=pad(Math.floor(r/3600)); if(m) m.textContent=pad(Math.floor(r%3600/60)); if(s) s.textContent=pad(r%60); }
    tick(); setInterval(tick,1000);
  });
  document.addEventListener('click', function(ev){
    var hd=ev.target.closest && ev.target.closest('.faq-header'); if(!hd) return;
    var f=hd.closest('.faq'); if(f) f.classList.toggle('active');
  });
  function form(){ return document.getElementById('ga-product-form'); }
  function syncRsi(v){
    try{ var u=new URL(location.href); if(u.searchParams.get('variant')!==String(v)){ u.searchParams.set('variant',v); history.replaceState(history.state,'',u.toString()); } }catch(e){}
    try{ if(window._rsiV2&&window._rsiV2.getState&&window._rsiV2.getState().currentVariantId!==v) window._rsiV2.setState({currentVariantId:v}); }catch(e){}
  }
  function choose(i){
    var items=[].slice.call(document.querySelectorAll('.pl-items .pl-item'));
    items.forEach(function(it,k){ it.classList.toggle('selected',k===i); var r=it.querySelector('input'); if(r) r.checked=(k===i); });
    var v=(window.GA_VARIANTS||[])[i]; var f=form(); var inp=f&&f.querySelector('[name="id"]');
    if(v&&inp){ inp.value=v; syncRsi(Number(v)); }
    window.GA_PACK=i;
  }
  document.addEventListener('click', function(ev){
    var it=ev.target.closest && ev.target.closest('.pl-items .pl-item'); if(!it) return;
    ev.preventDefault();
    var items=[].slice.call(document.querySelectorAll('.pl-items .pl-item')); choose(items.indexOf(it));
  });
  function trigger(){ var f=form(); if(!f) return null; var t=f.querySelector('.ga-rsi-trigger');
    if(!t){ t=document.createElement('button'); t.type='button'; t.className='ga-rsi-trigger _rsi-cod-form-pagefly-button-overwrite-v2 _rsi-cod-form-gempages-button-overwrite _rsi-cod-form-is-gempage es-popup-button-overwrite'; t.setAttribute('aria-hidden','true'); t.tabIndex=-1; t.textContent='Comprar'; t.style.cssText='position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);border:0;opacity:0;'; f.appendChild(t); }
    return t; }
  function buy(){
    var i=typeof window.GA_PACK==='number'?window.GA_PACK:0; choose(i);
    var codApp=!!(window._RSI_COD_FORM_SETTINGS||document.querySelector('script[src*="releasit"],script[src*="easysell"]')||window.EASYSELL_CONFIG);
    var f=form(); if(codApp){ var t=trigger(); if(t) t.click(); return; }
    if(f){ if(f.requestSubmit) f.requestSubmit(); else f.submit(); }
  }
  document.addEventListener('click', function(ev){
    var b=ev.target.closest && ev.target.closest('[data-ga-buy], [data-goto-element]'); if(!b) return;
    ev.preventDefault(); buy();
  });
  function boot(){ trigger(); var items=[].slice.call(document.querySelectorAll('.pl-items .pl-item')); var s=items.findIndex(function(x){return x.classList.contains('selected');}); choose(s<0?0:s); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  window.addEventListener('load',function(){ choose(typeof window.GA_PACK==='number'?window.GA_PACK:0); });
  function stickyInit(){
    var sticky=document.getElementById('964658'), sec=document.getElementById('932867');
    if(!sticky) return;
    function upd(){ if(!sec){ sticky.style.display=''; return; } var r=sec.getBoundingClientRect(); sticky.style.display=(r.top<=window.innerHeight&&r.bottom>=0)?'none':''; }
    window.addEventListener('scroll', upd, {passive:true}); upd();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',stickyInit); else stickyInit();
})();
